import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { showErrorMessage } from '~/domain/utils';
import { factoryGetCandidateOnsiteInterviewListKey } from '../factories/queries';
import { PermanentJobsService } from '../services';
import type {
  IGetCandidateOnsiteInterviewListPayload,
  IGetCandidateOnsiteInterviewListResult,
} from '../types';

interface IUseGetCandidateOnsiteInterviewListOptions {
  enabled?: boolean;
}

export const useGetCandidateOnsiteInterviewList = (
  payload: IGetCandidateOnsiteInterviewListPayload,
  options?: IUseGetCandidateOnsiteInterviewListOptions,
) => {
  const { data, error, isFetching, isLoading, isError } = useQuery<
    IGetCandidateOnsiteInterviewListResult,
    Error
  >({
    queryKey: factoryGetCandidateOnsiteInterviewListKey(payload),
    queryFn: () => PermanentJobsService.getCandidateOnsiteInterviewList(payload),
    retry: false,
    enabled: options?.enabled ?? true,
  });

  useEffect(() => {
    if (error) {
      showErrorMessage({ error });
    }
  }, [error]);

  return {
    data,
    error,
    isError,
    isInitialLoading: isLoading,
    isLoading: isLoading || isFetching,
  };
};
